module.exports = __webpack_public_path__ + "media/gôr bpen oh gàat an-dee têe pŏm jà ao bayn CLH hâa-săam maa tàai tam-má.2f420fc4.mp3";